// src/pages/produtos/produtos/DashProdutos.js
import React, { useEffect, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBox, FaBoxes, FaExclamationTriangle, FaShoppingCart, FaStore, FaChartBar } from "react-icons/fa";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";

import "../../../components/leiaute/Content.css";
import { fetchData } from "../../../services/Api";
import { formatCurrency } from "../../../utils/numberUtils";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const chartColors = ["#007bff", "#28a745", "#ffc107", "#dc3545", "#6c757d", "#17a2b8", "#fd7e14", "#20c997", "#6610f2", "#e83e8c"];

function DashProdutos() {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const formatDate = (date) => date.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formatDate(firstDayOfMonth));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [dash, setDash] = useState({
    cards: {
      produtosAtivos: 0,
      produtosDelivery: 0,
      produtosEsgotados: 0,
      produtosEstoqueBaixo: 0,
      quantidadeVendida: 0,
      valorVendido: 0,
    },
    topProdutosVendidos: [],
    vendasPorGrupo: [],
    estoquePorGrupo: [],
    produtosEstoqueBaixo: [],
    statusDelivery: [],
  });

  useEffect(() => {
    const fetchDashProdutos = async () => {
      try {
        const params = {
          DataIni: startDate,
          DataFim: `${endDate} 23:59:59`,
        };

        const data = await fetchData("/DashProduto", params);
        setDash({
          cards: data.cards || {},
          topProdutosVendidos: data.topProdutosVendidos || [],
          vendasPorGrupo: data.vendasPorGrupo || [],
          estoquePorGrupo: data.estoquePorGrupo || [],
          produtosEstoqueBaixo: data.produtosEstoqueBaixo || [],
          statusDelivery: data.statusDelivery || [],
        });
      } catch (error) {
        console.error("Erro ao carregar o dashboard de produtos:", error);
      }
    };

    fetchDashProdutos();
  }, [startDate, endDate]);

  const barTopProdutos = useMemo(() => ({
    labels: dash.topProdutosVendidos.map((item) => item.descricao),
    datasets: [
      {
        label: "Quantidade vendida",
        data: dash.topProdutosVendidos.map((item) => item.qtdeVendida),
        backgroundColor: "#007bff",
      },
    ],
  }), [dash.topProdutosVendidos]);

  const pieVendasGrupo = useMemo(() => ({
    labels: dash.vendasPorGrupo.map((item) => item.descricao),
    datasets: [
      {
        data: dash.vendasPorGrupo.map((item) => item.valorVendido),
        backgroundColor: chartColors,
      },
    ],
  }), [dash.vendasPorGrupo]);

  const barEstoqueGrupo = useMemo(() => ({
    labels: dash.estoquePorGrupo.map((item) => item.descricao),
    datasets: [
      {
        label: "Estoque atual",
        data: dash.estoquePorGrupo.map((item) => item.estoqueAtual),
        backgroundColor: "#28a745",
      },
    ],
  }), [dash.estoquePorGrupo]);

  const pieStatusDelivery = useMemo(() => ({
    labels: dash.statusDelivery.map((item) => item.descricao),
    datasets: [
      {
        data: dash.statusDelivery.map((item) => item.qtde),
        backgroundColor: ["#28a745", "#dc3545", "#6c757d"],
      },
    ],
  }), [dash.statusDelivery]);

  const cards = dash.cards || {};

  return (
    <div className="p-4 dashboard-scroll">
      <div className="d-flex justify-content-between align-items-center mb-3" style={{ marginTop: "-20px" }}>
        <h2>Dashboard de Produtos</h2>

        <div className="d-flex">
          <div className="me-2" style={{ maxWidth: "130px" }}>
            <label htmlFor="dashProdutosStartDate" className="form-label">Data Inicial:</label>
            <input
              type="date"
              id="dashProdutosStartDate"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div style={{ maxWidth: "130px" }}>
            <label htmlFor="dashProdutosEndDate" className="form-label">Data Final:</label>
            <input
              type="date"
              id="dashProdutosEndDate"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: "#f8f9fa", border: "none" }}>
            <div className="card-body">
              <FaBox size={40} color="#007bff" className="mb-3" />
              <h5 className="card-title text-primary">Produtos Ativos</h5>
              <p className="card-text fs-2 fw-bold text-dark">{cards.produtosAtivos || 0}</p>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: "#e2f0d9", border: "none" }}>
            <div className="card-body">
              <FaShoppingCart size={40} color="#28a745" className="mb-3" />
              <h5 className="card-title text-success">Valor Vendido</h5>
              <p className="card-text fs-2 fw-bold text-dark">{formatCurrency(cards.valorVendido || 0)}</p>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: "#fff3cd", border: "none" }}>
            <div className="card-body">
              <FaBoxes size={40} color="#ffc107" className="mb-3" />
              <h5 className="card-title text-warning">Qtde Vendida</h5>
              <p className="card-text fs-2 fw-bold text-dark">{Number(cards.quantidadeVendida || 0).toFixed(2)}</p>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card text-center shadow-sm" style={{ backgroundColor: "#ffecec", border: "none" }}>
            <div className="card-body">
              <FaExclamationTriangle size={40} color="#dc3545" className="mb-3" />
              <h5 className="card-title text-danger">Estoque Baixo</h5>
              <p className="card-text fs-2 fw-bold text-dark">{cards.produtosEstoqueBaixo || 0}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3 mt-1">
        <div className="col-md-6">
          <div className="card text-center shadow-sm" style={{ backgroundColor: "#eef5ff", border: "none" }}>
            <div className="card-body">
              <FaStore size={36} color="#0d6efd" className="mb-2" />
              <h6 className="card-title text-primary mb-1">Produtos no Delivery</h6>
              <div className="fs-2 fw-bold text-dark">{cards.produtosDelivery || 0}</div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card text-center shadow-sm" style={{ backgroundColor: "#fff7e6", border: "none" }}>
            <div className="card-body">
              <FaExclamationTriangle size={36} color="#fd7e14" className="mb-2" />
              <h6 className="card-title mb-1" style={{ color: "#fd7e14" }}>Produtos Esgotados</h6>
              <div className="fs-2 fw-bold text-dark">{cards.produtosEsgotados || 0}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Top 10 Produtos Mais Vendidos</h5>
              <Bar data={barTopProdutos} />
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Venda por Grupo</h5>
              <Pie data={pieVendasGrupo} />
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Status Delivery</h5>
              <Pie data={pieStatusDelivery} />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="card-title mb-0">Estoque por Grupo</h5>
                <FaChartBar title="Estoque por grupo" />
              </div>
              <div className="mt-2">
                <Bar data={barEstoqueGrupo} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Produtos com Estoque Baixo</h5>
              <div className="table-responsive">
                <table className="table table-sm table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Produto</th>
                      <th className="text-end">Estoque</th>
                      <th className="text-end">Mínimo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dash.produtosEstoqueBaixo.map((item) => (
                      <tr key={item.produtoId}>
                        <td>{item.descricao}</td>
                        <td className="text-end">{Number(item.estoqueAtual || 0).toFixed(2)}</td>
                        <td className="text-end">{Number(item.estoqueMin || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                    {dash.produtosEstoqueBaixo.length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">Nenhum produto com estoque baixo.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashProdutos;
